import React, { useEffect, useRef, useState } from "react";

export const AnimatedProgressCircle = ({
  containerSize,
  circfleRadius,
  color,
}) => {
  const circleRef = useRef();
  const totalLength = 2 * 3.14 * circfleRadius;

  const [circleStyle, setCircleStyle] = useState({
    strokeDasharray: totalLength + "px",
    strokeDashoffset: totalLength + "px",
  });

  const containerStyle = {
    position: "relative",
    width: containerSize + "px",
    height: containerSize + "px",
  };

  const svgStyle = {
    width: containerSize + "px",
    height: containerSize + "px",
    position: "absolute",
  };

  useEffect(() => {
    if (totalLength > 0) {
      let i = 0;
      const interval = setInterval(() => {
        setCircleStyle((prev) => {
          i++;
          return {
            strokeDasharray: totalLength + "px",
            strokeDashoffset: totalLength - (i / 100) * totalLength + "px",
          };
        });
      }, 10);
      return () => {
        clearInterval(interval);
      };
    }
  }, []);

  return (
    <div style={containerStyle}>
      <svg style={svgStyle}>
        <circle
          ref={circleRef}
          style={circleStyle}
          cx={containerSize / 2}
          cy={containerSize / 2}
          r={circfleRadius}
          fill="transparent"
          stroke={color}
          strokeWidth="2"
        />
      </svg>
    </div>
  );
};
